module.exports = __webpack_public_path__ + "img/android-chrome-install.f8891591.png";